module.exports = __webpack_public_path__ + "static/media/Origin.d4d92f45.svg";